import { useAuthStore } from './auth';
import { useCartStore } from './cart';
import { useProductStore } from './product';
import { useRequisitionProductStore } from './requisitionProduct';

export const createPiniaStoreProxy = () => {
  return {
    get getters() {
      const auth = useAuthStore();
      const cart = useCartStore();
      const product = useProductStore();
      const req = useRequisitionProductStore();
      return {
        get token() { return auth.token },
        get userData() { return auth.userData },
        get userAllPermissions() { return auth.userAllPermissions },
        get userRoutes() { return auth.userRoutes },
        get cartTotal() { return cart.cartTotal },
        get cartQuantity() { return cart.cartQuantity },
        get countCartItems() { return cart.countCartItems },
        get cartItems() { return cart.cartItems },
        get cartInfo() { return cart.cartInfo },
        get requisitionProductItems() { return req.requisitionProductItems },
        get productItems() { return product.productItems },
        get requsitionItems() { return product.requsitionItems },
      }
    },
    get state() {
      const cart = useCartStore();
      const product = useProductStore();
      const req = useRequisitionProductStore();
      return {
        get cart() { return cart },
        get product() { return product },
        get RequisitionProduct() { return req }
      }
    },
    dispatch(action, payload) {
      const auth = useAuthStore();
      const cart = useCartStore();
      const product = useProductStore();
      const req = useRequisitionProductStore();

      if (typeof auth[action] === 'function') return auth[action](payload);
      if (typeof cart[action] === 'function') return cart[action](payload);
      if (typeof product[action] === 'function') return product[action](payload);
      if (typeof req[action] === 'function') return req[action](payload);
      
      console.warn('Action not found in Pinia:', action);
    },
    commit(mutation, payload) {
      const auth = useAuthStore();
      const cart = useCartStore();
      const product = useProductStore();
      const req = useRequisitionProductStore();

      // Auth Store mappings
      if (mutation === 'UPDATE_USER') return auth.setUser(payload);
      if (mutation === 'UPDATE_USER_TOKEN') return auth.setToken(payload);
      if (mutation === 'UPDATE_USER_ALL_PERMISSIONS') return auth.setUserAllPermissions(payload);
      if (mutation === 'UPDATE_USER_ROUTES') return auth.setUserRoutes(payload);
      if (mutation === 'UPDATE_USER_NAVIGATIONS') return auth.setUserNavigations(payload);
      if (mutation === 'UPDATE_USER_DATA_CHECK' || mutation === 'UPDATE_DATA_CHECK') return auth.setDataCheck(payload);
      if (mutation === 'LOGOUT') return auth.logout(payload);

      // Maps Vuex mutations to Pinia actions
      if (typeof auth[mutation] === 'function') return auth[mutation](payload);
      if (typeof cart[mutation] === 'function') return cart[mutation](payload);
      if (typeof product[mutation] === 'function') return product[mutation](payload);
      if (typeof req[mutation] === 'function') return req[mutation](payload);

      console.warn('Mutation not found in Pinia:', mutation);
    }
  }
}
